<mat-dialog-content class="mat-typography" style="max-width: 469px;width:100%;">
  <div class="section_login">
    <button style="outline: none;" *ngIf="data.userType.access != 'restric'" class="close-button forgetPass"
      [mat-dialog-close]="true" id="closeBtn">
      <img src="../../../assets/icons/x-button.svg">
    </button>

    <div class="row">
      <div class="col-sm-12">
        <img height="82px" width="82px" style="float: left;" [defaultImage]="defaultImage" [lazyLoad]="data.userType.imgPath">
      </div>
      <div class="col-sm-12 successTitle">
        <h2>{{data.userType.titleOne}}</h2>
        <p>{{data.userType.text}}</p>
      </div>

      <div class="col-md-12">
        <button *ngIf="data.userType.access == 'access'" mat-raised-button color="warn" [mat-dialog-close]="true"
          (click)="okBtnClick()" class="authSignIn">OK</button>
        <button *ngIf="data.userType.access == 'restric'" mat-raised-button color="warn" [mat-dialog-close]="true"
          (click)="reloadClick()" class="authSignIn"><mat-icon class="headerMenuIcon">cached</mat-icon>&nbsp;
          Reload</button>

        <button *ngIf="data.userType.access == 'eventsAdd'" mat-raised-button color="warn" [mat-dialog-close]="true"
          (click)="EventAddClick()" class="authSignIn">
          Ok</button>

          <button *ngIf="data.userType.access == 'eventsManage'" mat-raised-button color="warn" [mat-dialog-close]="true"
          (click)="EventAddManageClick()" class="authSignIn">
          Ok </button>





      </div>

      <div class="col-md-12">
        <button *ngIf="data.userType.access == 'teamCode'" mat-raised-button color="warn" [mat-dialog-close]="true"
          class="authSignIn">OK</button>

      </div>


    </div>
  </div>
</mat-dialog-content>
